import * as React from 'react'

const useKeyBinding = (callback?: (e: KeyboardEvent) => void) => {
  React.useEffect(() => {
    const handler = (e: KeyboardEvent) => callback?.(e)
    document.addEventListener('keydown', handler, true)

    return () => document.removeEventListener('keydown', handler, true)
  }, [callback])
}

export default useKeyBinding
